// extracted by mini-css-extract-plugin
export default {"custom-loader":"Loader_custom-loader__jQJx9","s10":"Loader_s10__byxDW"};